import React, { Component } from 'react';
import Config from './Config';
import List from './List';
//import { Scrollbars } from 'react-custom-scrollbars';
import FX from './functions/functions';
//import OrderEdge from './OrderEdge';

class Tariff extends Component {  constructor(props) {
  super(props);
    this.state = {tariffs:[]};
  }
  componentDidMount(){
    this.retrieveData();
  }
  retrieveData = (limit) => {
    var data = {customer_id: this.props.root.state.customer_id};
    var qs = FX.encodeQueryData(data, true);
    FX.load(this.props.root,'tariffs' + qs, (res, i) => {
      console.log(res);
      this.setState({ tariffs : res.tariff });
      this.props.root.loadNextPage =  this.retrieveData;
    });
  }
  componentWillMount(){
    var n = window.location.pathname.split('/');
    var x = [];
    for (var i = 0; i < n.length; i++){
      if(n[i]){
        x.push(n[i]);
      }
    }
    console.log(x);
    var found = false;
    if(x[1] && parseInt(x[1],10)){
        console.log(parseInt(x[1],10));
        var root_state = this.props.root.state;
        this.props.root.state.current_customer[x[0]].list.some(
        (ping) => {
          if(  parseInt(ping.id,10) ===  parseInt(x[1],10)){
            root_state.detail = ping;
            return found = true;
          }
          return false;
        }
        );
     }
      if (x[1] && !found) {
        this.retrieveDetail(parseInt(x[1],10));
        //console.log('/' + x[0]);
        //FX.navigate.bind(this,state.panel, undefined ,'/' + x[0],state,true)();
        //window.location = '/' + x[0];
      }
  }
  retrieveDetail = (id) => {
    console.log('pop');
    var sort_str = this.props.root.sort_str ? this.props.root.sort_str : '';
    var data = {id: id};
    var qs = FX.encodeQueryData(data, true);
    FX.load(this.props.root,'product_detail' + qs , (res, i) => {
      var detail = this.props.root.setState({detail: res.product});
    });
  }
  render() {
    console.log(this.state);
    var dispatch;
    if(this.state.tariffs && this.state.tariffs.dispatch){
      var dispatch = this.state.tariffs.dispatch.map((tar) => {
          return (
              <tr>
                <td><span dangerouslySetInnerHTML={{__html: '&pound;'}} />{tar.order}</td>
                <td><span dangerouslySetInnerHTML={{__html: '&pound;'}} />{tar.line}</td>
                <td><span dangerouslySetInnerHTML={{__html: '&pound;'}} />{tar.pick}</td>
              </tr>
          )
      })
     }
    var storageH;
    var storageT;
    if(this.state.tariffs && this.state.tariffs.storage){
      var storageH = this.state.tariffs.storage.map((tar) => {
          return (
            <th>
                {tar.storage_type}
            </th>
         )
      });
      var storageT = this.state.tariffs.storage.map((tar) => {
          return (
            <td>
                <span dangerouslySetInnerHTML={{__html: '&pound;'}} />{tar.rate}
            </td>
         )
      });
     }
      return (
        <div className="Tariff">
          Tariff
          <h2>Dispatch</h2>
          <table className="dispatchPrices">
              <tr>
                <th>Order</th>
                <th>Line</th>
                <th>Pick</th>
              </tr>
              {dispatch}
          </table>
          <h2>Storage</h2>
          <table className="dispatchPrices">
              <tr>{storageH}</tr>
              <tr>{storageT}</tr>
          </table>
        </div>
      );
  }
}

export default Tariff;



// WEBPACK FOOTER //
// ./src/Tariff.js